import type { PricingSettings } from "@workspace/api-client-react";

export const PRICING_CONFIG: PricingSettings = {
  pkrToBdtDivisor: 2.2,
  roundToBDT: 100,
  tiers: [
    { maxPKR: 5_000, markupBDT: 400 },
    { maxPKR: 7_500, markupBDT: 800 },
    { maxPKR: 10_000, markupBDT: 1_000 },
    { maxPKR: 15_000, markupBDT: 2_000 },
    { maxPKR: 20_000, markupBDT: 3_000 },
    { maxPKR: 25_000, markupBDT: 4_000 },
    { maxPKR: 30_000, markupBDT: 5_000 },
  ],
  aboveLastTierMarkupRate: 0.2,
};

export function finalPriceBDT(
  sourcePrice: string | number,
  config: PricingSettings = PRICING_CONFIG,
): number {
  const originalPrice = Number(sourcePrice);
  if (!Number.isFinite(originalPrice) || originalPrice < 0) {
    throw new Error("Invalid source price.");
  }

  const tier = config.tiers.find(({ maxPKR }) => originalPrice <= maxPKR);
  const markup = tier?.markupBDT ?? originalPrice * config.aboveLastTierMarkupRate;
  const unroundedTotal = originalPrice / config.pkrToBdtDivisor + markup;
  return Math.round(unroundedTotal / config.roundToBDT) * config.roundToBDT;
}

export const formatBDT = (value: number) => `৳${value.toLocaleString("en-BD")}`;